import {
  AllCarsMotors64,
  Cars64,
  CarsFromDealerships64,
  NewCars64,
  Commercials64,
  PlantMachinery64,
  VintageCars64,
  Motorbikes64,
  DamagedCars64,
  MotorbikeExtras64,
  Boats64,
  BoatExtras64,
  Campers64,
  Caravans64,
  CarExtras64,
  CarParts64,
  CoachesBuses64,
  ModifiedCars64,
  OtherMotors64,
  Quads64,
  RallyCars64,
  Scooters64,
  Trailers64,
  Trucks64,
  VintageBikes64,
} from '../../../components/Toolkit/Base64/Sections';

export interface Map {
  [name: string]: JSX.Element;
}

const MotorsIcons: Map = {
  cars: <Cars64 />,
  carsfromdealerships: <CarsFromDealerships64 />,
  'new-cars': <NewCars64 />,
  commercials: <Commercials64 />,
  plantmachinery: <PlantMachinery64 />,
  vintagecars: <VintageCars64 />,
  motorbikes: <Motorbikes64 />,
  damagedcars: <DamagedCars64 />,
  boats: <Boats64 />,
  boatextras: <BoatExtras64 />,
  campers: <Campers64 />,
  caravans: <Caravans64 />,
  carextras: <CarExtras64 />,
  carparts: <CarParts64 />,
  coaches: <CoachesBuses64 />,
  modifiedcars: <ModifiedCars64 />,
  motorbikeextras: <MotorbikeExtras64 />,
  othermotor: <OtherMotors64 />,
  quads: <Quads64 />,
  rallycars: <RallyCars64 />,
  scooters: <Scooters64 />,
  trailers: <Trailers64 />,
  trucks: <Trucks64 />,
  vintagebikes: <VintageBikes64 />,
  motor: <AllCarsMotors64 />,
};

export default MotorsIcons;
